import { Award, Zap, Headphones, Gift } from "lucide-react";

const FEATURES = [
  {
    icon: Award,
    title: "Best market rates",
    body: "PamaPay offers the highest crypto-to-naira rates in Nigeria — period. We monitor competitors so you don't have to.",
  },
  {
    icon: Zap,
    title: "Rate match guarantee",
    body: "Found a better rate elsewhere? Show us, and we'll beat it. The only crypto-to-cash app that puts money where its mouth is.",
  },
  {
    icon: Headphones,
    title: "2-minute support response",
    body: "Average first-response time of 2 minutes across all channels. Real humans, not bots, ready when you need them.",
  },
  {
    icon: Gift,
    title: "₦1 per $1 referral",
    body: "Earn ₦1 for every $1 your referrals trade — forever. Refer one active trader and earn passively every month.",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 md:py-28 relative bg-white" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            Why PamaPay
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="features-title">
            Built for traders who refuse to settle for less.
          </h2>
          <p className="mt-5 text-base text-slate-600 max-w-xl">
            We didn't build another wallet — we built the cleanest path from your crypto to your bank account, with the best rates in the country backing it up.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className="group relative rounded-3xl border border-slate-200 bg-white p-7 sm:p-8 overflow-hidden transition-all duration-300 hover:border-[#3B6FBF]/40 hover:shadow-[0_8px_30px_-10px_rgba(59,111,191,0.25)]"
                data-testid={`feature-card-${i}`}
              >
                <div className="absolute -right-12 -top-12 w-32 h-32 rounded-full bg-[#3B6FBF]/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-2xl bg-[#3B6FBF]/10 border border-[#3B6FBF]/20 flex items-center justify-center text-[#3B6FBF] mb-5">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display font-bold text-xl mb-2 text-slate-900">{f.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{f.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
